export interface PassageHighlightSegment {
  text: string;
  highlight: boolean;
}

export function rankDrivenHeadingTag(
  level: number | null | undefined,
  kind: string | null | undefined
): string | null {
  if (kind === 'meta') return 'Meta';
  if (level != null && level >= 1 && level <= 6) return `H${level}`;
  return null;
}

/** Highlight keyword tokens in a passage (Google snippet-style). */
export function splitPassageByKeywordTokens(
  keyword: string,
  passage: string
): PassageHighlightSegment[] {
  const source = (passage || '').trim();
  if (!source) return [{ text: '', highlight: false }];

  const tokens = (keyword || '')
    .toLowerCase()
    .split(/[^a-z0-9]+/)
    .filter((t) => t.length >= 2);
  if (!tokens.length) return [{ text: source, highlight: false }];

  const lower = source.toLowerCase();
  const flags = new Array<boolean>(source.length).fill(false);

  const sorted = [...tokens].sort((a, b) => b.length - a.length);
  for (const term of sorted) {
    let idx = 0;
    while (idx < lower.length) {
      const pos = lower.indexOf(term, idx);
      if (pos === -1) break;
      for (let i = pos; i < pos + term.length; i++) flags[i] = true;
      idx = pos + term.length;
    }
  }

  const segments: PassageHighlightSegment[] = [];
  let i = 0;
  while (i < source.length) {
    const flag = flags[i];
    let j = i + 1;
    while (j < source.length && flags[j] === flag) j++;
    segments.push({ text: source.slice(i, j), highlight: flag });
    i = j;
  }
  return segments.filter((s) => s.text.length > 0);
}
